import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { ManageModalScreenName } from './types';
import { stateName } from './constants';
export const initialState = {
  fundraiser: undefined,
  charities: [],
  selectedCharity: null,
  currentModalScreen: ManageModalScreenName.Overview,
  uiState: UiState.Idle
};

const fetchFundraiserConfiguration = draft => {
  draft.uiState = UiState.Pending;
};

const setFailureState = draft => {
  draft.uiState = UiState.Failure;
};

const setFundraiserConfiguration = (draft, action) => {
  const {
    fundraiser
  } = action.payload;
  draft.fundraiser = fundraiser;
  draft.selectedCharity = fundraiser.charity || null;
  draft.currentModalScreen = fundraiser.active ? ManageModalScreenName.Overview : ManageModalScreenName.CharitySelect;
  draft.uiState = UiState.Success;
};

const manageFundraiserConfiguration = draft => {
  draft.uiState = UiState.Pending;
};

const stopActiveFundraiser = draft => {
  draft.uiState = UiState.Pending;
};

const fetchCharitiesSuccess = (draft, action) => {
  const {
    charities
  } = action.payload;
  draft.charities = charities;
};

const setSelectedCharity = (draft, action) => {
  const {
    charity
  } = action.payload;
  draft.selectedCharity = charity;
  draft.currentModalScreen = ManageModalScreenName.Overview;
};

const setCurrentModalScreen = (draft, action) => {
  const {
    screenName
  } = action.payload;
  draft.currentModalScreen = screenName;
};

const fundraiserSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchFundraiserConfiguration,
    fetchFundraiserConfigurationSuccess: setFundraiserConfiguration,
    fetchFundraiserConfigurationFailure: setFailureState,
    manageFundraiserConfiguration,
    manageFundraiserConfigurationSuccess: setFundraiserConfiguration,
    manageFundraiserConfigurationFailure: setFailureState,
    stopActiveFundraiser,
    stopActiveFundraiserFailure: setFailureState,
    fetchCharitiesSuccess,
    fetchCharitiesFailure: setFailureState,
    setSelectedCharity,
    setCurrentModalScreen
  }
});
export const {
  actions
} = fundraiserSlice;
export const plug = {
  [stateName]: fundraiserSlice.reducer
};
export default fundraiserSlice.reducer;